import type { Map } from 'immutable'
import _get from 'lodash/get'
import requestImport from '../../request'
import { createAuthorization } from '../../auth'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- untyped JS service, matches qa-generate-api
const request = requestImport as any

const ASSETS_ENDPOINT = 'v1/assets'

export type CreateAssetJsonBody = {
  originalFileName: string
  fileBase64: string
  contentId: number
  contentType: string
  contentReferenceType: string
  language: string
  primaryLanguage?: string
}

/**
 * Creates a Brooklyn asset via JSON body with fileBase64.
 * Prefer this over multipart services/assets createAsset when SHA256 fileHash is
 * required (yi-embedded-image article embeds). Multipart uploads store a quoted
 * MD5/ETag instead.
 */
export async function createAssetJson ({
  auth,
  server,
  body,
}: {
  auth: Map<string, unknown>
  server: string
  body: CreateAssetJsonBody
}): Promise<Record<string, unknown>> {
  const res = await request
    .post(`${server}/${ASSETS_ENDPOINT}`)
    .set('authorization', createAuthorization(auth) ?? '')
    .set('content-type', 'application/json')
    .set('accept', 'application/json')
    .send({
      originalFileName: body.originalFileName,
      fileBase64: body.fileBase64,
      primaryLanguage: body.primaryLanguage ?? body.language,
      contentId: body.contentId,
      contentType: body.contentType,
      contentReferenceType: body.contentReferenceType,
      language: body.language,
    })
  return _get(res, 'body', {})
}
